import React from 'react';
import GlobalExpansionDashboard from '../../components/global/GlobalExpansionDashboard';

const GlobalExpansionDashboardPage = () => {
  return (
    <div>
      <GlobalExpansionDashboard />
    </div>
  );
};

export default GlobalExpansionDashboardPage;
